// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__P4hlu","header":"ReportDetails_header__3p2b_","title":"ReportDetails_title__2sJwD","left":"ReportDetails_left__1vFpG"};